module.exports = __webpack_public_path__ + "img/img11.01b5ef59.png";